export default __webpack_public_path__ + "i/ce42124d3aa35a66804b299feea51552.png";